import React, { useState } from "react";
import ClientHeader from "../../client-header/components/index";
import ClientFooter from "../../client-footer/components/index";

const ClientContact = () => {
  const [formData, setFormData] = useState({ name: "", email: "", subject: "", message: "" });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission logic here
    alert("Message sent! (Placeholder)");
  };

  return (
    <>
      <ClientHeader />
      <main className="overflow-hidden">
        
        {/* --- HERO SECTION --- */}
        <section className="homepad-about py-5" style={{ backgroundColor: "#f4f7f6" }}>
          <div className="container py-lg-5 text-center">
            <div className="row justify-content-center">
              <div className="col-lg-8">
                <h6 className="text-success font-weight-bold text-uppercase mb-3" style={{ letterSpacing: "2px" }}>
                  Get In Touch
                </h6>
                <h1 className="font-weight-bold montserrat text-primary mb-4" style={{ fontSize: "3.5rem", lineHeight: "1.1" }}>
                  We'd Love To <span className="text-success">Hear From You.</span>
                </h1>
                <p className="font-size-18 text-muted line-hight-3 mb-0">
                  Whether you have a question about our programs, want to partner with us, or are looking to support our mission, our team is ready to answer all your questions.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* --- CONTACT FORM & INFO SECTION --- */}
        <section className="py-5 my-4">
          <div className="container py-lg-4">
            <div className="row g-5 align-items-center">
              
              {/* Left Column: Contact Info */}
              <div className="col-lg-5">
                <h2 className="font-weight-bold montserrat text-primary font-size-32 mb-4">Contact Information</h2>
                <p className="text-muted font-size-16 mb-5">
                  Reach out to us directly through the following channels. We aim to respond to all inquiries within 24-48 business hours.
                </p>

                <div className="d-flex mb-4">
                  <div className="bg-primary rounded-circle p-3 me-4 d-flex align-items-center justify-content-center flex-shrink-0" style={{ width: "50px", height: "50px" }}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></svg>
                  </div>
                  <div>
                    <h5 className="font-weight-bold mb-1">Email Us</h5>
                    <p className="text-muted mb-0">Info@justgen.org</p>
                  </div>
                </div>

                <div className="d-flex mb-4">
                  <div className="bg-success rounded-circle p-3 me-4 d-flex align-items-center justify-content-center flex-shrink-0" style={{ width: "50px", height: "50px" }}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>
                  </div>
                  <div>
                    <h5 className="font-weight-bold mb-1">Call Us</h5>
                    <p className="text-muted mb-0">+(757) 276-3191</p>
                  </div>
                </div>

                <div className="d-flex mb-4">
                  <div className="bg-primary rounded-circle p-3 me-4 d-flex align-items-center justify-content-center flex-shrink-0" style={{ width: "50px", height: "50px" }}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg>
                  </div>
                  <div>
                    <h5 className="font-weight-bold mb-1">Visit Us</h5>
                    <p className="text-muted mb-0">P.O. Box 4656, Norfolk,<br />Hampton Roads, Virginia 23513</p>
                  </div>
                </div>
              </div>

              {/* Right Column: Form */}
              <div className="col-lg-7">
                <div className="card border-0 shadow-lg rounded-4 p-4 p-md-5" style={{ backgroundColor: "#ffffff" }}>
                  <h3 className="font-weight-bold font-size-28 mb-4 text-primary">Send Us a Message</h3>
                  <form onSubmit={handleSubmit}>
                    <div className="row g-4">
                      <div className="col-md-6">
                        <label className="form-label font-size-14 font-weight-semibold">Your Name</label>
                        <input type="text" className="form-control form-control-lg bg-light border-0" name="name" value={formData.name} onChange={handleChange} placeholder="John Doe" required />
                      </div>
                      <div className="col-md-6">
                        <label className="form-label font-size-14 font-weight-semibold">Your Email</label>
                        <input type="email" className="form-control form-control-lg bg-light border-0" name="email" value={formData.email} onChange={handleChange} placeholder="john@example.com" required />
                      </div>
                      <div className="col-12">
                        <label className="form-label font-size-14 font-weight-semibold">Subject</label>
                        <input type="text" className="form-control form-control-lg bg-light border-0" name="subject" value={formData.subject} onChange={handleChange} placeholder="How can we help?" required />
                      </div>
                      <div className="col-12">
                        <label className="form-label font-size-14 font-weight-semibold">Message</label>
                        <textarea className="form-control form-control-lg bg-light border-0" name="message" rows="4" value={formData.message} onChange={handleChange} placeholder="Write your message here..." required></textarea>
                      </div>
                      <div className="col-12 mt-5">
                        <button type="submit" className="btn btn-success btn-lg w-100 font-weight-bold py-3 rounded-3">
                          Send Message
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>

            </div>
          </div>
        </section>
      </main>
      <ClientFooter />
    </>
  );
};

export default ClientContact;